import type { Options, Parameters, SupportedLangs } from '../types';

import { NameStringParser } from '../NameStringParser';
import { NamesFormatterContext } from './NamesFormatterContext';

// ---

export type Names = {
  short?: string;
  long?: string;
  full?: string;
};

export class NamesFormatter {
  static Format(
    lang: SupportedLangs,
    formatterCtx: NamesFormatterContext | null,
    params: Parameters,
    names: Names | undefined,
    options?: {
      showErrors?: boolean;
    },
  ): NonNullable<Names> | null {
    const resultNames: Names = {
      short: '',
      long: '',
      full: '',
    };

    const formatterOptions = (options || {}) as Options;

    if (formatterOptions?.showErrors === undefined) {
      formatterOptions.showErrors = true;
    }

    if (formatterCtx !== null) {
      if (typeof names?.short === 'string') {
        try {
          resultNames.short = NameStringParser
            .Parse(names.short)
            .format(lang, formatterCtx, params, formatterOptions);
        }
        catch (error) {
          console.error(error);
        }
      }

      if (typeof names?.long === 'string') {
        try {
          resultNames.long = NameStringParser
            .Parse(names.long)
            .format(lang, formatterCtx, params, formatterOptions);
        }
        catch (error) {
          console.error(error);
        }
      }

      if (typeof names?.full === 'string') {
        try {
          resultNames.full = NameStringParser
            .Parse(names.full)
            .format(lang, formatterCtx, params, formatterOptions);
        }
        catch (error) {
          console.error(error);
        }
      }
    }

    if (!resultNames.short && !resultNames.long && !resultNames.full) {
      return null;
    }

    return resultNames;
  }
}
